export default "__VITE_ASSET__CIvc6tI6__"